var React = require('react');

function PFFBrandIconsThinClose (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#022137;}\n"),React.createElement("g",{"id":"Designs","key":1},React.createElement("polygon",{"className":"st0","points":"550.6,190.6 529.4,169.4 360,338.8 190.6,169.4 169.4,190.6 338.8,360 169.4,529.4 190.6,550.6 \n\t\t360,381.2 529.4,550.6 550.6,529.4 381.2,360 \t"})),React.createElement("g",{"id":"Layer_2","key":2})]);
}

PFFBrandIconsThinClose.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 720 720","style":{"enableBackground":"new 0 0 720 720"},"xmlSpace":"preserve"};

module.exports = PFFBrandIconsThinClose;

PFFBrandIconsThinClose.default = PFFBrandIconsThinClose;
